import { getSupabase } from "./client";

export type FrequentAirportRow = {
  icao: string;
  leg_count: number;
};

export async function fetchFrequentAirportsFromDb(
  limit = 60
): Promise<{ data: FrequentAirportRow[] | null; error: string | null }> {
  const sb = getSupabase();
  if (!sb) return { data: null, error: "Supabase is not configured." };
  const { data, error } = await sb.rpc("frequent_airports", { p_limit: limit });
  if (error) return { data: null, error: error.message };
  const rows = (data ?? []) as { icao: string; leg_count: number | string }[];
  return {
    data: rows.map((r) => ({
      icao: String(r.icao ?? "").trim().toUpperCase(),
      leg_count: Number(r.leg_count) || 0,
    })),
    error: null,
  };
}
